import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { auth } from "./firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import Home from "./routes/home/Home";
import Navbar from "./components/navbar/Navbar";
import Auth from "./routes/auth/Auth";
import SignUp from "./routes/auth/signup/SignUp";
import Organize from "./routes/organize/Organize";
import Register from "./routes/register/Register";
import Planner from "./routes/planner/Planner";
import About from "./routes/about/About";
import Profile from "./routes/profile/Profile";
import TournamentProvider from "./routes/tournament/TournamentContext";
import ResetPassword from "./routes/auth/reset-password/ResetPassword";
import Archive from "./routes/archive/Archive";
import MyTournaments from "./routes/my-tournaments/MyTournaments";

function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const checkUser = onAuthStateChanged(auth, (user) => {
      if (!!user) {
        setUser(user);
      } else {
        setUser(undefined);
      }
    });

    return checkUser;
  }, []);

  console.log("app render");

  return (
    <BrowserRouter>
      <Navbar isLoggedIn={!!user} />
      <div className="pb-40 mt-20 pt-4 flex flex-col items-center overscroll-none bg-stone-100 min-h-[80vh]">
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/auth" element={<Auth isLoggedIn={!!user} />} />
          <Route path="/auth/signup" element={<SignUp isLoggedIn={!!user} />} />
          <Route
            path="/auth/reset-password"
            element={<ResetPassword isLoggedIn={!!user} />}
          />
          <Route
            path="/:tournamentId"
            element={<TournamentProvider user={user} />}
          />
          <Route
            path="/:tournamentId/register"
            element={<Register user={user} />}
          />
          <Route path="/organize" element={<Organize user={user} />} />
          <Route path="/archive" element={<Archive />} />
          <Route
            path="/my-tournaments"
            element={<MyTournaments user={user} />}
          />
          <Route path="/planner" element={<Planner />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<Profile user={user} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
